import { GetDeleteOfficeData, CreateOfficeData ,UpdateOfficeData,OfficeData,ReturnUpdateDelete} from "@/types";
import { PostRequest ,PostRequestFormData} from "./requests";

export const getByOfficeID = async (data: GetDeleteOfficeData): Promise<OfficeData> => {
    try {
        return await PostRequest<OfficeData>("/api/office/get", data);
    } catch (error) {
        console.log('Error in getByOfficeID:', error);
        throw error;
    }
}

export const createOffice = async (data: CreateOfficeData) => {
    try {
        return await PostRequestFormData("/api/office/create", data);
    } catch (error) {
        console.log('Error in createOffice:', error);
        throw error;
    }
}

export const getAllOffices = async (): Promise<OfficeData[]> => {
    try {
        return await PostRequest<OfficeData[]>("/api/office/get_all", {});
    } catch (error) {
        console.log('Error in getAllCOffices:', error);
        throw error;
    }
}

export const updateOffice = async (data: UpdateOfficeData): Promise<ReturnUpdateDelete> => {
    try {
        return await PostRequestFormData("/api/office/update", data);
    } catch (error) {
        console.log('Error in updateOffice:', error);
        throw error;
    }
}

export const deleteOffice = async (data: GetDeleteOfficeData): Promise<ReturnUpdateDelete> => {
    try {
       return await PostRequest<ReturnUpdateDelete>("/api/office/delete", data);
    } catch (error) {
        console.log('Error in deleteOffice:', error);
        throw error;
    }
}